/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface DeleteRecurringUrlaubsansprueche$Params {
  Ids: Array<string>;
}

export function deleteRecurringUrlaubsansprueche(http: HttpClient, rootUrl: string, params: DeleteRecurringUrlaubsansprueche$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, deleteRecurringUrlaubsansprueche.PATH, 'delete');
  if (params) {
    rb.query('Ids', params.Ids, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

deleteRecurringUrlaubsansprueche.PATH = '/v1/recurringurlaubsansprueche';
